import { clsx } from 'clsx';
import { Icon } from '@/app/kit';

/**
 * A spinning ball. Always has an accessible label; `showLabel` prints it too.
 *
 *   <Spinner label="Loading the box score" showLabel />
 */
export interface SpinnerProps {
  label: string;
  size?: number;
  showLabel?: boolean;
  className?: string;
}

export function Spinner({ label, size = 24, showLabel = false, className }: SpinnerProps) {
  return (
    <span role="status" className={clsx('inline-flex items-center gap-2 font-semibold', className)}>
      <span className="inline-flex animate-spin" aria-hidden="true">
        <Icon name="ball" size={size} fill="var(--color-peach)" />
      </span>
      <span className={showLabel ? undefined : 'sr-only'}>{label}</span>
    </span>
  );
}
